import {connect} from 'react-redux';
import ValidationIdCurpView from '../../components/views/mx/ValidationIdCurpView';
import {State} from '../../../../types/mx/reducers';
import * as ValidationIdDataStepActions from '../../actions/mx/ValidationIdDataStepActions';
import * as ModalActions from '../../../../../wizard/actions/ModalActions';

const mapStateToProps = (state: State) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        onPressOk: (curp, token) => {
            dispatch(ValidationIdDataStepActions.RESEND_CURP_TO_ID_VALIDATION_ACTION
                .action(curp, token));
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
        },
    };
};

const ValidationIdCurpContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ValidationIdCurpView);

export default ValidationIdCurpContainer;
